import React from "react";
import { Box, Grid } from "@mui/material";
import { Controller as Fc } from "react-hook-form";

const QuestionTrueOrFalse = ({ setValue, control, item, customStyle }) => {
  return (
    <Grid container spacing={"10px"}>
      {item.choices.length > 0 &&
        item.choices.map((ch, chKey) => (
          <Grid item xs={12} md={12} key={chKey}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Fc
                name={`answer[_${item.id}]`}
                control={control}
                render={({ field }) => {
                  return (
                    <>
                      <input
                        {...field}
                        checked={field?.value === ch.id}
                        onChange={() => {
                          setValue(`answer[_${item.id}]`, ch.id);
                        }}
                        type="radio"
                        id={`flexRadioDefault1dfdsf7788${ch.id}`}
                        style={{
                          width: "20px",
                          height: "20px",
                          accentColor:
                            customStyle?.accentColor ?? "var(--color-black)",
                        }}
                        className="custom-radio"
                      />
                      <label
                        htmlFor={`flexRadioDefault1dfdsf7788${ch.id}`}
                        style={{
                          marginTop: "5px",
                          marginLeft: "5px",
                          fontWeight: 400,
                          fontSize: "14px",
                          lineHeight: "24px",
                          fontFamily: `var(--font-${customStyle?.bodyFont})`,
                          color: customStyle?.textColor ?? "#19181B",
                        }}
                      >
                        {ch.options}
                      </label>
                    </>
                  );
                }}
              />
            </Box>
          </Grid>
        ))}
    </Grid>
  );
};

export default QuestionTrueOrFalse;
